import {
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { AuthContext } from "context/auth.context";
import { clipboardOutline, copyOutline, createOutline, logOutOutline, optionsOutline } from "ionicons/icons";
import { ROLES } from "models/roles.enum";
import React, { useContext } from "react";

const Menu = () => {

  const { logout, logInfo } = useContext(AuthContext)
  const isAdmin = logInfo.Role?.includes(ROLES.iProEmployee);
  // console.log({isProUser});

  const AdminMenu = () => {
    return (
      <div>
        <IonMenuToggle autoHide={true}>
          <IonItem routerLink="/domains">
            Domains
            <IonIcon slot="end" icon={optionsOutline}></IonIcon>
          </IonItem>
        </IonMenuToggle>
        <IonMenuToggle autoHide={true}>
          <IonItem routerLink="/templates">
            Templates
            <IonIcon slot="end" icon={copyOutline}></IonIcon>
          </IonItem>
        </IonMenuToggle>
      </div>
    )
  }

  return (
    <IonMenu side="start" menuId="adminMenu" contentId="maincontent" type="overlay">
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>Menu</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          <IonMenuToggle autoHide={true}>
            <IonItem routerLink="/home">
              Patient Forms
              <IonIcon slot="end" icon={clipboardOutline}></IonIcon>
              </IonItem>
          </IonMenuToggle>
          <IonMenuToggle autoHide={true}>
            <IonItem routerLink="/phqs">
              Designer
              <IonIcon slot="end" icon={createOutline}></IonIcon>
            </IonItem>
          </IonMenuToggle>
          {isAdmin && <AdminMenu />}
          <IonMenuToggle autoHide={true}>
            <IonItem button detail onClick={logout}>
              Logout
              <IonIcon slot="end" icon={logOutOutline}></IonIcon>
              </IonItem>
          </IonMenuToggle>
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
